const loader = (data) => {
  const retVal = data;
  /*
  const retVal = {'models':{'bq':{}}}
  data.forEach(col=>{
    if(col.name){
      retVal['models']['bq'][col.name] = col
    }
  })
  */
  return retVal;
};

export default loader;
